import ApiService from './api.service';
import store from '../store';
import router from '../router';

const authService = {
    logout: async () => {
        try {
            let response = await ApiService.post('auth/logout');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    signIn: async payload => {
        try {
            let response = await ApiService.post('auth/signin', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    signUp: async payload => {
        try {
            let response = await ApiService.post('auth/signupWithEDS', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    refreshToken: async () => {
        try {
            let response = await ApiService.post('auth/refreshToken');
            return response.data;
        } catch (e) {
            console.error(e);
            return e.response.data;
        }
    },
    verifyEmail: async secretHash => {
        try {
            let response = await ApiService.post('auth/verifyEmail', { secretHash });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    restorePassword: async payload => {
        try {
            let response = await ApiService.post('auth/restorePassword', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    updatePassword: async payload => {
        try {
            let response = await ApiService.put('auth/updatePassword', payload);
            return response.data;
        } catch (err) {
            console.error(err);
        }
    },
    changePassword: async payload => {
        try {
            let response = await ApiService.put('auth/changePassword', payload);
            return response.data;
        } catch (err) {
            console.error(err);
        }
    },
    isSecretHashExists: async secretHash => {
        try {
            let response = await ApiService.get('auth/checkSecretHash', {
                params: {
                    secretHash
                }
            });
            return response.data;
        } catch (err) {
            console.error(err);
        }
    },
    getPermissions: async () => {
        try {
            let response = await ApiService.get('permissions');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default authService;
